import { useScreenSize } from '../components/window-size-listener/store';

export const useResponsive = () => {
  return useScreenSize((state) => state.breakpointValues);
};
